<template>
  <popup ref="popup" :loading="popupLoading" :appendToBody="true">
    <div slot="body" style="margin-top:-15px">
      {{ idx + "/" + sizeConus }}

      <el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="120px" size="mini">
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="formParameter.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" prop="sex">
              <el-input v-model="formParameter.sex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学历" prop="grade">
              <el-input v-model="formParameter.grade"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="手机" prop="mobile">
              <el-input v-model="formParameter.mobile" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出生年月" prop="age">
              <el-date-picker v-model="formParameter.age" type="month" placeholder="选择年月" default-value="2000-01-01">
                >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="email" prop="email"><el-input v-model="formParameter.email"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="毕业学校" prop="schoolid">
              <el-input v-model="formParameter.schoolid" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="毕业时间" prop="gradedate">
              <el-date-picker v-model="formParameter.gradedate" type="year" placeholder="选择年">
              </el-date-picker></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="专业" prop="subject"><el-input v-model="formParameter.subject"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="类型" prop="type">
              <el-input v-model="formParameter.type" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据渠道平台" prop="recruid">

              <div>【{{ formParameter.zpname }}@{{ formParameter.ptname }}】</div>

            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="岗位" prop="post">
              <el-input v-model="formParameter.post" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="电邀" prop="dyer">
              <el-input v-model="formParameter.dyer" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="咨询" prop="zxer">
              <el-input v-model="formParameter.zxer" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="技术" prop="jser">
              <el-input v-model="formParameter.jser" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="电邀时间" prop="invitetime">
              <el-date-picker v-model="formParameter.invitetime" type="datetime" placeholder="选择电邀时间"
                default-time="14:00:00">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邀约上门时间" prop="interviewtime">
              <el-date-picker v-model="formParameter.interviewtime" type="datetime" placeholder="选择上门时间"
                default-time="14:00:00">
              </el-date-picker></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="state">
              <el-input v-model="formParameter.state" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="备注" prop="remark"><el-input v-model="formParameter.remark"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item  v-has-permission-code-and="'1000001501345'"  label="简历" prop="resumea">
              <el-image  title="有时看不见点要点多几次"  v-if="formParameter.hasresume" style="width:59px; height: 25px" :src="'/static/shresume.png'" :preview-src-list="[(baseUrl +'/statics/resume24364/'+ formParameter.mobile+'.jpg?'+Math.random())]">
              </el-image>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table class="table" :data="listRecords" stripe border height="auto">
        <el-table-column label="序号" width="50px" type="index"></el-table-column>
        <el-table-column prop="gjdate" label="跟进时间" width="140px">
        </el-table-column>
        <el-table-column prop="uid" width="100px" label="跟进人">
        </el-table-column>
        <el-table-column width="80px" prop="rank" label="评级">
          <template slot-scope="scope">
            <el-tag type="danger" size="mini" v-if="scope.row.rank == 1">D量</el-tag>
            <el-tag type="warning" size="mini" v-if="scope.row.rank == 2">C量</el-tag>
            <el-tag size="mini" v-if="scope.row.rank == 3">B量</el-tag>
            <el-tag type="success" size="mini" v-if="scope.row.rank == 4">A量</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="评价"> </el-table-column>
      </el-table>
    </div>
    <div slot="footer" style="text-align: center">
      <el-button :type="prebtn" size="medium" round :loading="confirmLoading" @click="move(-1)">{{ prebtn == 'primary' ?
    "上一条" : "--end--" }}</el-button>
      <el-button type="danger" @click="close" size="medium">关闭</el-button>
      <el-button :type="nextbtn" size="medium" round :loading="confirmLoading" @click="move(1)">{{ nextbtn == 'primary' ?
    "下一条" : "--end--" }}</el-button>
    </div>
  </popup>
</template>

<script>

import popup from "@/components/popup/drawerPopup.vue";
import apircd from "@/api/consu/consultationxl/consultationxl.js";
import constant from "@/util/constant.js";

export default {
  name: "edit",
  components: {
    popup,
  },
  data() {
    return {
      baseUrl: constant.serverUrl ,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      qdaolist: [],
      listRecords: [],
      sizeRecord: 0,

      listConus: [],
      idx: 1,
      sizeConus: 1,
      prebtn: 'info',
      nextbtn: 'primary'

    };
  },
  methods: {
   
 
    //打开弹框
    open(index, list, title, disabled, size) {

      this.listConus = list;
      this.sizeConus = this.listConus.length;
      this.idx = index + 1
      this.prebtn = 'info'
      this.nextbtn = 'primary'

      this.formParameter = this.listConus[index];
      this.parameter = this.formParameter;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    }, move(flag) {
      if ((flag < 0 && this.idx > 1) || (flag > 0 && this.idx < this.sizeConus)) {
        this.idx += flag;

        if (this.idx == 1) {
          this.prebtn = 'info'
        } else if (this.idx == this.sizeConus) {
          this.nextbtn = 'info'
        } else {
          this.prebtn = 'primary'
          this.nextbtn = 'primary'
        }

        this.confirmLoading = true;

        this.formParameter = this.listConus[this.idx - 1];

        apircd.listRcds({ coid: this.formParameter.id }, (res) => {
          if (res.data.records) {
            this.listRecords = res.data.records;
            if (this.listRecords) this.sizeRecord = this.listRecords.length;
          }
          this.confirmLoading = false;
        });
      }
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容

      //编辑查询数据
      let parameter = {
        id: this.parameter.id,
      };
      // api.toUpdate(parameter, (res) => {
      //   this.formParameter = res.data.record;
      //    this.qdaolist = res.data.qd;
      apircd.listRcds({ coid: this.parameter.id }, (res1) => {
        if (res1.data.records) {
          this.listRecords = res1.data.records;
          this.popupLoading = false;
        }
      });
      // });

    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
